import { forwardRef, PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import styles from '../../widget/widget.module.scss';
import { WidgetType } from 'modules/dashboard/types';
import HiddenWidget from 'modules/dashboard/components/atoms/widget-hidden/HiddenWidget';

interface WidgetContentProps {
  type?: WidgetType;
  hideMode?: 'widget' | 'content';
  isScrollable?: boolean;
  hasScrollbar: boolean;
  isContentVisible: boolean;
  isWidgetHidden: boolean;
  children: React.ReactNode;
}

export const WidgetContent = forwardRef<HTMLDivElement, WidgetContentProps>(
  (
    {
      type,
      hideMode,
      isScrollable,
      hasScrollbar,
      isContentVisible,
      isWidgetHidden,
      children
    }: PropsWithChildren<WidgetContentProps>,
    ref
  ) => {
    if (hideMode === 'widget' || hideMode == null) {
      return (
        <div
          data-testid={`${type}ContentContainer`}
          ref={ref}
          className={clsx(
            styles.widgetContent,
            hasScrollbar ? styles.scrollableInner : '',
            isScrollable ? styles.scrollable : '',
            isContentVisible ? styles.fadeIn : styles.fadeOut,
            isWidgetHidden ? styles.hiddenWidget : ''
          )}
        >
          {isWidgetHidden ? <HiddenWidget /> : children}
        </div>
      );
    }

    return (
      <div
        ref={ref}
        className={clsx([
          styles.widgetContent,
          isScrollable ? styles.scrollable : '',
          hasScrollbar ? styles.temp : '',
          isContentVisible ? styles.dissolveIn : styles.dissolveOut
        ])}
      >
        <div data-testid={`${type}ContentContainer`} className={clsx(styles.scrollableInner)}>
          {children}
        </div>
      </div>
    );
  }
);

WidgetContent.displayName = 'WidgetContent';
